import React from 'react';
import { useSelector } from 'react-redux';

import useGoLogin from 'hooks/useGoLogin';
import ModalRoute from './ModalRoute';

const PrivateModalRoute = ({ ...props }) => {
	const { LoginRedirect } = useGoLogin(false);

	const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

	if (isLoggedIn) {
		return <ModalRoute {...props} />;
	}

	return <LoginRedirect />;
};

export default PrivateModalRoute;
